var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowleft = function SvgArrowleft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 10,
    fill: "none",
    viewBox: "0 0 17 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#827127",
    d: "M5.5.5 1 4.902 5.5 9.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#827127",
    strokeLinecap: "square",
    d: "M1.5 5h14.04"
  })));
};
export default SvgArrowleft;